import classNames from "classnames";
import { ReactNode } from "react";

export function Row(props: {
	clzName?: string
	children: ReactNode
}) {
	const {
		clzName,
		children
	} = props;

	return (
		<div className={classNames(clzName, "layout__horizontal")} >
			{children}
		</div>
	)
}